import { render, staticRenderFns } from "./IconQrcode.vue?vue&type=template&id=f2090564"
import script from "./IconQrcode.vue?vue&type=script&lang=js"
export * from "./IconQrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports